<template>
  <div>
    <video autoplay muted loop id="bg-video">
      <source src="../../assets/video/login.mp4" type="video/mp4" />
    </video>

    <b-modal
      v-model="show"
      hide-footer
      centered
      header-class="border-0"
      hide-header
      no-close-on-esc
      no-close-on-backdrop
    >
      <div style="text-align: right">
        <h5>
          <a href="/logout">Logout <i class="mdi mdi-logout"></i></a>
        </h5>
      </div>
      <hr />
      <Search
        class="p-4"
        :options="options"
        @loadLocation="loadLocation"
      ></Search>
    </b-modal>
  </div>
</template>
<script>
import Search from "@/components/dashboard/search";
import { mapActions } from "vuex";
import gisMixin from "../../mixins/gis";

export default {
  mixins: [gisMixin],
  props: {
    show: Boolean,
  },
  data() {
    return {
      options: [],
      isLoading: false,
    };
  },
  components: {
    Search,
  },
  async mounted() {
    const res = await this.FetchGISLocationAndGroups();
    this.options = res.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  },
  methods: {
    ...mapActions("gis", ["setLocation", "setGroup", "setDevices"]),
    async loadLocation(selectedLocation) {
      // eslint-disable-next-line no-case-declarations
      const locationDevices = await this.GetAllDevices();
      // eslint-disable-next-line no-console
      this.setLocation({
        id: selectedLocation.id,
        name: selectedLocation.name,
      });
      this.setDevices(locationDevices);
      this.$emit("loadDashboard");
    },
  },
};
</script>
<style scoped>
#bg-video {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1039;
}

.header-div {
  position: absolute;
  z-index: 2000;
  padding: 10px;
  width: 100%;
  left: 30%;
}

.header-1 {
  color: #556ee6;
}
.header-2 {
  color: #556ee6;
}

/deep/ .modal-backdrop {
  opacity: 0.8;
  width: 100% !important;
  height: 100% !important;
}

#header {
  -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 2s; /* Firefox < 16 */
  -ms-animation: fadein 2s; /* Internet Explorer */
  -o-animation: fadein 2s; /* Opera < 12.1 */
  animation: fadein 2s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
